/* ==========================================================================
   PURE MOROCCAN - Custom WOW Effects (JavaScript)
   Scroll-triggered animations using IntersectionObserver
   ========================================================================== */

(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* -----------------------------------------------------------------------
     Scroll Reveal - Fade in elements as they enter viewport
     ----------------------------------------------------------------------- */
  function initScrollReveal() {
    var sections = document.querySelectorAll([
      '.shopify-section--collection-list',
      '.shopify-section--featured-collection',
      '.shopify-section--text-with-icons',
      '.shopify-section--testimonials',
      '.shopify-section--newsletter',
      '.shopify-section--media-grid',
      '.shopify-section--rich-text'
    ].join(','));

    sections.forEach(function(section) {
      section.classList.add('wow-reveal');
    });

    // Stagger collection and testimonial items
    var staggerContainers = document.querySelectorAll(
      '.collection-list, .testimonial-list'
    );
    staggerContainers.forEach(function(container) {
      container.classList.add('wow-stagger');
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll(
      '.wow-reveal, .wow-reveal-left, .wow-reveal-right, .wow-reveal-scale, .wow-stagger'
    ).forEach(function(el) {
      observer.observe(el);
    });

    // Animate section headings underline
    var headings = document.querySelectorAll('.section-header .h2, .section-header .h1');
    var headingObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          headingObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    headings.forEach(function(h) {
      headingObserver.observe(h);
    });
  }

  /* -----------------------------------------------------------------------
     Product Card Tilt - Subtle 3D perspective on mouse move
     ----------------------------------------------------------------------- */
  function initCardTilt() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    document.querySelectorAll('product-card').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = (y - centerY) / centerY * -3;
        var rotateY = (x - centerX) / centerX * 3;

        card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
      });

      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)';
      });

      card.addEventListener('mouseenter', function() {
        card.style.transition = 'transform 0.15s ease-out';
      });
    });
  }

  /* -----------------------------------------------------------------------
     Parallax Scroll - Subtle depth on media grid images
     ----------------------------------------------------------------------- */
  function initParallax() {
    var mediaItems = document.querySelectorAll('.shopify-section--media-grid .content-over-media > img, .shopify-section--media-grid .content-over-media > picture img');

    if (mediaItems.length === 0) return;

    var ticking = false;

    function updateParallax() {
      mediaItems.forEach(function(img) {
        var rect = img.closest('.content-over-media').getBoundingClientRect();
        var viewH = window.innerHeight;
        if (rect.top < viewH && rect.bottom > 0) {
          var progress = (viewH - rect.top) / (viewH + rect.height);
          var offset = (progress - 0.5) * 20;
          img.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* -----------------------------------------------------------------------
     Counter Animation - Animate numbers when visible
     ----------------------------------------------------------------------- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-wow-counter]');
    if (counters.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-wow-counter'), 10);
          var duration = 2000;
          var start = 0;
          var startTime = null;

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(eased * target);
            if (progress < 1) requestAnimationFrame(animate);
          }

          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  /* -----------------------------------------------------------------------
     Initialize everything on DOM ready
     ----------------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initScrollReveal();
    initCardTilt();
    initParallax();
    initCounters();
  }
})();

/* ==========================================================================
   GA4 Tracking - Property 525401439 (G-MR617W5LB9)
   Google Consent Mode v2 + gtag config
   ========================================================================== */
(function() {
  var w = window, d = document;
  w.dataLayer = w.dataLayer || [];
  function t(){w.dataLayer.push(arguments);}
  w.gtag = t;

  t('consent', 'default', {
    'analytics_storage': 'denied',
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'wait_for_update': 500
  });

  var s = d.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=G-MR617W5LB9';
  d.head.appendChild(s);

  t('js', new Date());
  t('config', 'G-MR617W5LB9', { 'send_page_view': true });
})();
